/**
 * preview-filter-options — the option lists behind the preview filter menu,
 * plus the "how many filters are narrowing this list" summary the trigger
 * badge shows.
 *
 * Defaults are the widest setting (rank order, everything visible). Anything
 * else is counted so the collapsed trigger can still say the list is filtered
 * — otherwise hiding the chips behind an icon would hide the fact that rows
 * are missing.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { PreviewListSortMode, PreviewRankFilter } from '../preview-sort';
import type {
  PreviewOutcomeFilter,
  PreviewStatusFilter,
} from '../preview-list-filters';

export const SORT_OPTIONS = [
  { id: 'rank' as const, label: 'Rank' },
  { id: 'name' as const, label: 'Name' },
];

export const RANK_OPTIONS = [
  { id: 'all' as const, label: 'All' },
  { id: 'top5' as const, label: 'Top 5' },
  { id: 'top10' as const, label: 'Top 10' },
];

export const STATUS_OPTIONS = [
  { id: 'all' as const, label: 'All' },
  { id: 'active' as const, label: 'Active' },
  { id: 'inactive' as const, label: 'Inactive' },
  { id: 'excluded' as const, label: 'Excluded' },
  { id: 'no-excluded' as const, label: 'No excl.' },
];

export const OUTCOME_OPTIONS = [
  { id: 'all' as const, label: 'All' },
  { id: 'changed' as const, label: 'Changed' },
  { id: 'unchanged' as const, label: 'Unchanged' },
  { id: 'kept' as const, label: 'Kept' },
];

export const PREVIEW_FILTER_DEFAULTS = {
  sortMode: 'rank' as PreviewListSortMode,
  rankFilter: 'all' as PreviewRankFilter,
  statusFilter: 'all' as PreviewStatusFilter,
  outcomeFilter: 'all' as PreviewOutcomeFilter,
  poolFilter: null as string | null,
};

export interface PreviewFilterState {
  sortMode: PreviewListSortMode;
  rankFilter: PreviewRankFilter;
  statusFilter: PreviewStatusFilter;
  outcomeFilter: PreviewOutcomeFilter;
  poolFilter: string | null;
}

/** How many controls are off their default — 0 means "showing everything". */
export function activeFilterCount(state: PreviewFilterState): number {
  const d = PREVIEW_FILTER_DEFAULTS;
  let n = 0;
  if (state.sortMode !== d.sortMode) n++;
  if (state.rankFilter !== d.rankFilter) n++;
  if (state.statusFilter !== d.statusFilter) n++;
  if (state.outcomeFilter !== d.outcomeFilter) n++;
  if (state.poolFilter !== d.poolFilter) n++;
  return n;
}
